import { InlineLinkElement } from '@typedream/components';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_LINK } from '../../pluginKeys';

export const createLinkPlugin = createTElementPluginFactory({
  key: ELEMENT_LINK,
  component: InlineLinkElement,
  isInline: true,
});
